module.exports = __webpack_public_path__ + "media/images/emblems/Radelfingen-coat_of_arms-c3e59cc25ed688aea22e18004ea6da50.svg";